import { GenericFieldFactory } from "../../Common/_generics/GenericFieldFactory";

export const SubscriptionsSecondaryViewStore = GenericFieldFactory("SUBSCRIPTIONS_SECONDARY_VIEW", null);